module.exports = __webpack_public_path__ + "img/gerencia.65221033.jpg";